import type { OwnTransportType } from '@libs/trip-planner-interfaces';
import { ConnectionType, TransportType } from '@libs/trip-planner-interfaces';

export const DEFAULT_TRANSPORT_TYPE = ConnectionType.NONE;
export const DEFAULT_TRANSPORT_TYPE_BETWEEN_DESTINATION = ConnectionType.CAR;

export const isFlightTransport = (fromType: ConnectionType): boolean =>
  fromType === ConnectionType.FLIGHT;

export const isFerryTransport = (fromType: ConnectionType): boolean =>
  fromType === ConnectionType.FERRY;

export const isBookableTransport = (fromType: ConnectionType): boolean =>
  isFlightTransport(fromType) || isFerryTransport(fromType);

export const isSimpleTransportType = (type: TransportType): boolean =>
  type === TransportType.Car ||
  type === TransportType.Walk ||
  type === TransportType.Bicycle;

export function getConnectionTypeFromOwnTransportType(
  ownTransportType: OwnTransportType
): ConnectionType {
  switch (ownTransportType) {
    case TransportType.Car:
      return ConnectionType.CAR;
    case TransportType.Bicycle:
      return ConnectionType.BICYCLE;
    case TransportType.Walk:
      return ConnectionType.WALK;
    case TransportType.None:
      return ConnectionType.NONE;
    default:
      throw new Error('No Transport in hotel Ingredient');
  }
}
